import React from 'react'
import Icon from '../common/components/Icon'

const Answer = ({ question, answer, onClick }) =>
	<div>
		<h2>
			<button onClick={onClick}>
				<Icon icon="arrow-left" size="small" />
				Retour
			</button>
			<div className="faq__answer-title">{question.title}</div>
		</h2>
		{answer}
	</div>

export default Answer





// WEBPACK FOOTER //
// ./src/js/faq/Answer.js